import { useUsers } from '../../../lib/supabase/users/supabaseUserService';
import { useModelFixedShifts } from '../../../lib/supabase/shifts/fixed/supabaseFixedShiftService';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { LoadingState } from '../../ui/loading-state';
import { getUserName } from '../../../utils/format';
import { SplitWeekRecurringShiftCalendarView } from '../../ui/calendar/split-week-recurring-shift-calendar-view';

interface ModelRecurringShiftsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  model_id: string;
  modelName: string;
}

export const ModelRecurringShiftsDialog = ({
  isOpen,
  onClose,
  model_id,
  modelName
}: ModelRecurringShiftsDialogProps) => {
  const { data: recurringShifts = [], isLoading: shiftsLoading } = useModelFixedShifts(model_id);
  const { data: users = [], isLoading: usersLoading } = useUsers();

  if (shiftsLoading || usersLoading) {
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="max-w-6xl h-[90vh]">
          <DialogHeader>
            <DialogTitle>Fixed Shifts - {modelName}</DialogTitle>
          </DialogHeader>
          <LoadingState />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl">
        <DialogHeader>
          <DialogTitle>Fixed Shifts - {modelName}</DialogTitle>
        </DialogHeader>
        
        <div className="p-0 m-0">
          <SplitWeekRecurringShiftCalendarView
            events={recurringShifts}
            onEventClick={() => {}}
            showToolbar={false}
            allowNavigation={false}
            getModelName={() => modelName}
            getUserName={(user_id) => getUserName(users, user_id)}
            permissions={[]}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};